import _ from 'lodash';

export function errorSafeSaga(sagaFunc) {
    return function* handleError(args) {
        try {
            yield sagaFunc(args);
        } catch (error) {
            console.error("error", error);
        }
    };
}

export function handleDefaultResponses(types, state, action) {
    if (_.includes(types, action.type)) {
        return {
            ...state,
            [action.type]: action.payload
        };
    } else {
        return {
            ...state,
        };
    }
}



// WEBPACK FOOTER //
// ./src/service/StoreService.js